import { AuthProvider } from './commons/contexts/AuthContext';
import { VersionProvider } from './commons/contexts/VersionContext';
import { App as AntApp, ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <VersionProvider>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: '#C395EB',
                  colorPrimaryHover: '#AF86D3',
                },
              }}
            >
              <AntApp>
                <AppRoutes />
              </AntApp>
            </ConfigProvider>
          </VersionProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
